/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import { PiAsteriskThin, PiSnowflakeBold, PiBed } from 'react-icons/pi';
import { MdEventSeat } from 'react-icons/md';
import AppChip from '../../../shared/components/app-chip/AppChip';
import {
  formatCurrency,
  isMobileWidth,
} from '../../../shared/helper-utils/appUtils';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppCheckBox from '../../../shared/components/app-check-box/AppCheckBox';
import AppButton from '../../../shared/components/app-button/AppButton';

function BusFilters({
  minPrice,
  maxPrice,
  selectedFilters,
  allBusTypes,
  allBusOperators,
  onApplyFilter,
}) {
  const [selectedMinPrice, setSelectedMinPrice] = useState(minPrice);
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(maxPrice);

  const [selectedDepartureTimes, setSelectedDepartureTimes] = useState(
    selectedFilters.selectedDepartureTimes,
  );
  const [selectedArrivalTimes, setSelectedArraivalTimes] = useState(
    selectedFilters.selectedArrivalTimes,
  );
  const [selectedBusTypes, setSelectedBusTypes] = useState(
    selectedFilters.selectedBusTypes,
  );
  const [selectedOperators, setSelectedOperators] = useState(
    selectedFilters.selectedOperators,
  );
  const [selectedBusName, setSelectedBusName] = useState(
    selectedFilters.selectedBusName,
  );
  const [selectedAcTypes, setSelectedAcTypes] = useState(
    selectedFilters.selectedAcTypes,
  );
  const [selectedLayoutTypes, setSelectedLayouttypes] = useState(
    selectedFilters.selectedLayoutTypes,
  );
  useEffect(() => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
  }, [minPrice, maxPrice]);

  useEffect(() => {
    setSelectedDepartureTimes(selectedFilters.selectedDepartureTimes);
    setSelectedArraivalTimes(selectedFilters.selectedArrivalTimes);
    setSelectedOperators(selectedFilters.selectedOperators);
    setSelectedBusTypes(selectedFilters.selectedBusTypes);
    setSelectedAcTypes(selectedFilters.selectedAcTypes);
    setSelectedLayouttypes(selectedFilters.selectedLayoutTypes);
  }, [selectedFilters]);

  const handleChipSelection = (name, value) => {
    let list = [];
    if (name === 'departureTime') {
      list = [...selectedDepartureTimes];
    } else if (name === 'arraivalTime') {
      list = [...selectedArrivalTimes];
    } else if (name === 'busType') {
      list = [...selectedBusTypes];
    } else if (name === 'busOperator') {
      list = [...selectedOperators];
    } else if (name === 'acTypes') {
      list = [...selectedAcTypes];
    } else if (name === 'layoutTypes') {
      list = [...selectedLayoutTypes];
    }

    const index = list.indexOf(value);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(value);
    }
    if (name === 'departureTime') {
      setSelectedDepartureTimes(list);
    } else if (name === 'arraivalTime') {
      setSelectedArraivalTimes(list);
    } else if (name === 'busType') {
      setSelectedBusTypes(list);
    } else if (name === 'busOperator') {
      setSelectedOperators(list);
    } else if (name === 'acTypes') {
      setSelectedAcTypes(list);
    } else if (name === 'layoutTypes') {
      setSelectedLayouttypes(list);
    }
  };
  const handleSliderChange = (newValues) => {
    setSelectedMinPrice(newValues[0]);
    setSelectedMaxPrice(newValues[1]);
  };

  useEffect(() => {
    if (!isMobileWidth()) {
      onApplyFilter({
        selectedMinPrice,
        selectedMaxPrice,
        selectedDepartureTimes,
        selectedArrivalTimes,
        selectedBusTypes,
        selectedOperators,
        selectedBusName,
        selectedAcTypes,
        selectedLayoutTypes,
      });
    }
  }, [
    selectedMinPrice,
    selectedMaxPrice,
    selectedDepartureTimes,
    selectedArrivalTimes,
    selectedBusTypes,
    selectedOperators,
    selectedBusName,
    selectedAcTypes,
    selectedLayoutTypes,
  ]);

  const handleApplyMobileFilter = () => {
    onApplyFilter({
      selectedMinPrice,
      selectedMaxPrice,
      selectedDepartureTimes,
      selectedArrivalTimes,
      selectedBusTypes,
      selectedOperators,
      selectedBusName,
      selectedAcTypes,
      selectedLayoutTypes,
    });
  };
  const handleClearFilter = () => {
    onApplyFilter({
      selectedMinPrice: minPrice,
      selectedMaxPrice: maxPrice,
      selectedDepartureTimes: [],
      selectedArrivalTimes: [],
      selectedBusTypes: [],
      selectedOperators: [],
      selectedBusName: '',
      selectedAcTypes: [],
      selectedLayoutTypes: [],
    });
  };

  const stylesForSticky = () => {
    const styles = {
      div: {
        position: 'sticky',
        top: '166px',
        overflowY: 'scroll',
        maxHeight: 'calc(100vh - 203px)',
      },
    };
    if (!isMobileWidth()) {
      return styles;
    }
    const stylesForMobile = {
      div: {
        position: 'static',
      },
    };
    return stylesForMobile;
  };

  return (
    <section
      className="one-way-flight-filters pt-3"
      style={stylesForSticky.div}
    >
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">Price Range</div>
        <div>
          <span className="fs-12">
            {formatCurrency(selectedMinPrice)}-
            {formatCurrency(selectedMaxPrice)}
          </span>
        </div>
        <div className="my-3">
          <ReactSlider
            min={minPrice}
            max={maxPrice}
            value={[selectedMinPrice, selectedMaxPrice]}
            onChange={handleSliderChange}
          />
        </div>
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">
          Bus type/Operator
        </div>
        <div className="one-way-flight-filters_section_content">
          <AppTextInput
            name="selectedBusName"
            id="selectedBusName"
            placeholderText="Filter by Bus type/operator"
            className="me-3 fs-14"
            value={selectedBusName}
            onChange={(e) => setSelectedBusName(e.target.value)}
          />
        </div>
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">Bus Types</div>
        <div className="one-way-flight-filters_section_content">
          <div className="d-flex justify-content-between">
            <AppChip
              selected={selectedAcTypes.indexOf('ac') > -1}
              name="acTypes"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <PiSnowflakeBold className="fs-18" />
                  <span>AC</span>
                </div>
              }
              value="ac"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
            <AppChip
              selected={selectedAcTypes.indexOf('nonac') > -1}
              name="acTypes"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <PiAsteriskThin className="fs-18" />
                  <span>Non AC</span>
                </div>
              }
              value="nonac"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
          </div>
          <div className="d-flex justify-content-between">
            <AppChip
              selected={selectedLayoutTypes.indexOf('seater') > -1}
              name="layoutTypes"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <MdEventSeat className="fs-18" />
                  <span>Seater</span>
                </div>
              }
              value="seater"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
            <AppChip
              selected={selectedLayoutTypes.indexOf('sleeper') > -1}
              name="layoutTypes"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <PiBed className="fs-18" />
                  <span>Sleeper</span>
                </div>
              }
              value="sleeper"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
          </div>
        </div>
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">Depart Time</div>
        <div className="one-way-flight-filters_section_content">
          <div className="d-flex justify-content-between">
            <AppChip
              selected={selectedDepartureTimes.indexOf('0000-0599') > -1}
              name="departureTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/sunrise.svg" alt="" />
                  <span>00 -06</span>
                </div>
              }
              value="0000-0599"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
            <AppChip
              selected={selectedDepartureTimes.indexOf('0600-1199') > -1}
              name="departureTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/afternoon_sun.svg" alt="" />
                  <span>06 -12</span>
                </div>
              }
              value="0600-1199"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
          </div>
          <div className="d-flex justify-content-between">
            <AppChip
              selected={selectedDepartureTimes.indexOf('1200-1799') > -1}
              name="departureTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/evening_time.svg" alt="" />
                  <span>12-18</span>
                </div>
              }
              value="1200-1799"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
            <AppChip
              selected={selectedDepartureTimes.indexOf('1800-2399') > -1}
              name="departureTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/night_time.svg" alt="" />
                  <span>18-00</span>
                </div>
              }
              value="1800-2399"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
          </div>
        </div>
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">
          Arrival Times
        </div>
        <div className="one-way-flight-filters_section_content">
          <div className="d-flex justify-content-between">
            <AppChip
              selected={selectedArrivalTimes.indexOf('0000-0599') > -1}
              name="arraivalTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/sunrise.svg" alt="" />
                  <span>00 -06</span>
                </div>
              }
              value="0000-0599"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
            <AppChip
              selected={selectedArrivalTimes.indexOf('0600-1199') > -1}
              name="arraivalTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/afternoon_sun.svg" alt="" />
                  <span>06 -12</span>
                </div>
              }
              value="0600-1199"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
          </div>
          <div className="d-flex justify-content-between">
            <AppChip
              selected={selectedArrivalTimes.indexOf('1200-1799') > -1}
              name="arraivalTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/evening_time.svg" alt="" />
                  <span>12-18</span>
                </div>
              }
              value="1200-1799"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
            <AppChip
              selected={selectedArrivalTimes.indexOf('1800-2399') > -1}
              name="arraivalTime"
              chipText={
                <div className="d-flex gap-1 align-items-center justify-content-center">
                  <img src="/images/others/night_time.svg" alt="" />
                  <span>18-00</span>
                </div>
              }
              value="1800-2399"
              className="m-1 text-center flex-1"
              onClick={handleChipSelection}
            />
          </div>
        </div>
      </div>

      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">Operator</div>
        <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
          {allBusOperators.map((operator) => (
            <AppCheckBox
              key={operator}
              onChange={() => handleChipSelection('busOperator', operator)}
              name="busOperator"
              id={operator}
              labelText={operator}
              checked={selectedOperators.indexOf(operator) > -1}
            />
          ))}
        </div>
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header">Bus Type</div>
        <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
          {allBusTypes.map((busType) => (
            <AppCheckBox
              key={busType}
              onChange={() => handleChipSelection('busType', busType)}
              name="busType"
              id={busType}
              labelText={busType}
              checked={selectedBusTypes.indexOf(busType) > -1}
            />
          ))}
        </div>
      </div>
      {isMobileWidth() && (
        <div className="d-flex gap-2 position-fixed bottom-0 z-3 white-background-color p-1 w-100">
          <AppButton
            btnText="Apply"
            variant="primary"
            className="flex-1"
            onClick={handleApplyMobileFilter}
          />
          <AppButton
            btnText="clear"
            variant="outlined"
            className="flex-1"
            onClick={handleClearFilter}
          />
        </div>
      )}
    </section>
  );
}

BusFilters.propTypes = {
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  allBusTypes: PropTypes.array.isRequired,
  allBusOperators: PropTypes.array.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
};

export default BusFilters;
